import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";

import { LEVY_KEY_OPTIONS } from "layouts/dutyEstimator/constants";

const levyLabel = (value) => LEVY_KEY_OPTIONS.find((o) => o.value === value)?.label || value;

export default function levyOverrideTableData({ overrideList = [], onEdit, onDelete }) {
  return {
    columns: [
      { Header: "Category", accessor: "category", align: "left" },
      { Header: "Levy", accessor: "levy", align: "left" },
      { Header: "Effect", accessor: "effect", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: overrideList.map((override) => ({
      category: (
        <MDTypography variant="button" fontWeight="medium">
          {override?.category?.name || `#${override?.categoryId}`}
        </MDTypography>
      ),
      levy: (
        <MDBox>
          <MDTypography variant="button" fontWeight="medium" display="block">
            {levyLabel(override?.levyKey)}
          </MDTypography>
          {override?.notes ? (
            <MDTypography variant="caption" color="text">
              {override.notes}
            </MDTypography>
          ) : null}
        </MDBox>
      ),
      effect: override?.isExempt ? (
        <Chip
          size="small"
          label="Exempt (0%)"
          sx={{ backgroundColor: "#ffebee", color: "#c62828", fontWeight: 600 }}
        />
      ) : override?.overrideRate !== null && override?.overrideRate !== undefined ? (
        <Chip
          size="small"
          label={`${Number(override.overrideRate)}% (overridden)`}
          sx={{ backgroundColor: "#fff3e0", color: "#e65100", fontWeight: 600 }}
        />
      ) : (
        <MDTypography variant="caption" color="text">
          No-op — no rate set
        </MDTypography>
      ),
      status: (
        <Chip
          size="small"
          label={override?.isActive === false ? "Inactive" : "Active"}
          sx={{
            backgroundColor: override?.isActive === false ? "#eeeeee" : "#e8f5e9",
            color: override?.isActive === false ? "#616161" : "#2e7d32",
            fontWeight: 600,
          }}
        />
      ),
      actions: (
        <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
          <Button size="small" onClick={() => onEdit(override)}>
            Edit
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() => onDelete(override?.id)}
            sx={{ backgroundColor: "#d32f2f", color: "#fff", "&:hover": { backgroundColor: "#9a0007" } }}
          >
            Delete
          </Button>
        </MDBox>
      ),
    })),
  };
}
